import request from '@/utils/request';

export function getMyVipInfo() {
  return request({
    url: '/My/vipInfo',
  });
}

export function getMyVipAudioList() {
  return request({
    url: '/My/vipAudioList',
  });
}

export function getVipDetail(id) {
  return request({
    url: '/Vip/detail',
    params: {
      id,
    },
  });
}

export function getReceiveExperienceVipDetail(params) {
  return request({
    url: '/Vip/getReceiveExperienceVipDetail',
    params,
  });
}

export function receiveExperienceVip(data) {
  return request({
    url: '/Vip/receiveExperience',
    method: 'POST',
    data,
  });
}

export function inviteExperienceVip(id) {
  return request({
    url: '/Vip/inviteExperienceVip',
    params: {
      id,
    },
  });
}
